import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import linkify from 'vue-linkify'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.directive('linkified', linkify)
